import { render, staticRenderFns } from "./RenameDialog.vue?vue&type=template&id=64753802&scoped=true&"
import script from "./RenameDialog.vue?vue&type=script&lang=js&"
export * from "./RenameDialog.vue?vue&type=script&lang=js&"
import style0 from "./RenameDialog.vue?vue&type=style&index=0&id=64753802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64753802",
  null
  
)

export default component.exports